const styles = () => ({
  root: {
    height: '100vh'
  },
  titleBox: {
    background: "linear-gradient(180deg, rgba(38, 187, 237, 0.72) 0%, #26BBED 100%)",
    height: '50%',
    paddingBottom: 100
  },
  title: {
    fontSize: 40,
    color: '#fff',
    marginLeft: 16
  },
  actionBox: {
    background: '#fff',
    height: '50%',
    paddingTop: 60
  },
  text: {
    color: '#26BBED',
    fontSize: 24
  },
  buttonWrapper: {
    marginTop: 40
  },
  tourWrapper: {
    marginTop: 24,
    fontSize: 16
  },
  tour: {
    color: '#26BBED',
    fontWeight: 600,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  textStyle: {
    fontWeight: "600"
  }
});

export default styles;